<template>
  <div>
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="tcf-notedit" v-if="!isauth">
          <div class="tcf-notedit-spinner">
            未授权小程序，<router-link to="/work/delxcxsz" class="a-txt">点击这里立即去授权</router-link>
          </div>
        </div>
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="状态">
              <el-select v-model="searchForm.mark" clearable style="width: 100px">
                <el-option label="未处理" :value="0" />
                <el-option label="已处理" :value="1" />
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="请输入关键字" @keyup.enter.native="Search" />
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
          </el-form>
          <div v-loading="loading" class="card-content">
            <el-table
              :data="tableData"
              stripe
              style="width: 100%;margin-bottom: 20px">
              <el-table-column
                prop="nickname"
                label="昵称"
                width="100"
                align="center"
                show-overflow-tooltip
              />
              <el-table-column
                prop="username"
                label="真实姓名"
                width="100"
                align="center"
                show-overflow-tooltip
              />
              <el-table-column
                prop="time"
                label="时间"
                width="200"
                align="center"
                show-overflow-tooltip
              />
              <el-table-column
                prop="content"
                label="内容"
                min-width="300"
                align="center"
                show-overflow-tooltip
              />
              <el-table-column
                label="状态"
                width="100"
                align="center"
                fixed="right"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.mark===1" :disable-transitions="true" size="mini">已处理</el-tag>
                  <el-tag v-if="scope.row.mark===0" :disable-transitions="true" size="mini" type="danger">未处理</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="200"
                align="center"
                fixed="right"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <el-button v-if="scope.row.mark===0" icon="el-icon-edit" size="mini" @click="editRow(scope.row)">处理
                  </el-button>
                  <el-button v-if="scope.row.mark===1" icon="el-icon-search" size="mini" @click="editRow(scope.row)">
                    查看
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              v-if="total>0"
              background
              :current-page="currentPage"
              :page-sizes="[20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="投诉详情"
      :visible.sync="dialogVisible"
      width="40%"
    >
      <div v-loading="dloading">
        <table class="tcf-detail-table" cellpadding="0">
          <tr>
            <th>投诉人</th>
            <td colspan="3">{{ complaintsInfo.name }}</td>
          </tr>
          <tr>
            <th>投诉内容</th>
            <td colspan="3">{{ complaintsInfo.content }}</td>
          </tr>
          <tr>
            <th>图片</th>
            <td colspan="3">
              <el-image
                v-for="imgurl in complaintsInfo.imglist"
                style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
                :src="imgurl"
                :preview-src-list="complaintsInfo.imglist"
              />
            </td>
          </tr>
          <tr>
            <th>时间</th>
            <td colspan="3">{{ complaintsInfo.time }}</td>
          </tr>
        </table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          v-if="complaintsInfo.mark===0"
          :disabled="subLoading"
          type="primary"
          size="small"
          @click="editComplaints(complaintsInfo.cid)"
        >处理</el-button>
        <el-button size="small" @click="dialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getDelComplaintsList, getDelComplaintsImgList, editDelComplaints, getDelShopInfo } from '@/api/dealer'

export default {
  name: 'deltsyj',
  data() {
    return {
      searchForm: {
        mark: null,
        search: ''
      },
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      dialogVisible: false,
      dloading: false,
      complaintsInfo: {
        cid: null,
        mark: null,
        name: '',
        content: '',
        time: '',
        imglist: []
      },
      subLoading: false,
      isauth: true
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getData()
    getDelShopInfo({ delid: this.user.delid }).then(response => {
      if (response.data !== null && response.data !== undefined) {
        if (response.data.appid === null || response.data.appid === '' || response.data.appid === undefined) {
          this.isauth = false
        }
      } else {
        this.isauth = false
      }
    })
  },
  methods: {
    getData() {
      this.loading = true
      const data = {
        delid: this.user.delid,
        page: this.currentPage,
        limit: this.pageSize,
        mark: this.searchForm.mark,
        search: this.searchForm.search
      }
      getDelComplaintsList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    Search() {
      this.currentPage = 1
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    editRow(row) {
      this.dialogVisible = true
      this.dloading = true
      let _name = row.nickname
      if (row.username !== null && row.username !== undefined && row.username !== '') {
        _name += '（' + row.username + '）'
      }
      this.complaintsInfo.name = _name
      this.complaintsInfo.content = row.content
      this.complaintsInfo.time = row.time
      this.complaintsInfo.mark = row.mark
      this.complaintsInfo.cid = row.cid
      getDelComplaintsImgList({ cid: row.cid }).then(response => {
        this.dloading = false
        const imgs = []
        for (const img of response.data) {
          imgs.push(img.imgurl)
        }
        this.complaintsInfo.imglist = imgs
      }).catch(() => {
        this.dloading = false
      })
    },
    editComplaints(cid) {
      if (!this.subLoading) {
        this.subLoading = true
        editDelComplaints({ cid: cid }).then(response => {
          this.$message({
            type: 'success',
            message: response.msg
          })
          this.subLoading = false
          this.dialogVisible = false
          this.getData()
        }).catch(() => {
          this.subLoading = false
          this.dialogVisible = false
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
